var AuthModal = (function () {
  'use strict';

  var modal = null;

  function getModal() {
    if (!modal) {
      modal = document.getElementById('auth-modal');
    }
    return modal;
  }

  /**
   * Open the auth modal
   */
  function open() {
    var el = getModal();
    if (el) {
      el.classList.add('active');
    }
  }

  /**
   * Close the auth modal
   */
  function close() {
    var el = getModal();
    if (el) {
      el.classList.remove('active');
    }
  }

  /**
   * Toggle the auth modal
   */
  function toggle() {
    var el = getModal();
    if (!el) return;
    if (el.classList.contains('active')) {
      close();
    } else {
      open();
    }
  }

  /**
   * Copy text to clipboard. Returns a Promise that resolves to true on success.
   * Uses async Clipboard API with a textarea fallback for older browsers / non-secure contexts.
   */
  function copyToClipboard(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).then(function () {
          return true;
        }).catch(function () {
          return legacyCopy(text);
        });
      }
    } catch (e) { /* fall through */ }
    return Promise.resolve(legacyCopy(text));
  }

  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return !!ok;
    } catch (e) {
      return false;
    }
  }

  function getReturnTo() {
    var returnTo =
      window.location.pathname +
      (window.location.search || '') +
      (window.location.hash || '');

    return returnTo || '/';
  }

  function buildLoginUrl(options) {
    var opts = options || {};
    var base =
      (window.themeRoutes && window.themeRoutes.accountLogin) || '/account/login';
    var sep = base.indexOf('?') === -1 ? '?' : '&';
    var params = new URLSearchParams();

    params.set('return_to', getReturnTo());

    if (opts.email) {
      params.set('login_hint', opts.email);
      params.set('email', opts.email);
    }

    return base + sep + params.toString();
  }

  /**
   * Show a lightweight toast so the user knows the email was copied and what to do next
   * on the Shopify-hosted login page. Auto-removes after `duration` ms.
   */
  function showToast(message, duration) {
    var existing = document.getElementById('auth-toast');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var toast = document.createElement('div');
    toast.id = 'auth-toast';
    toast.className = 'auth-toast';
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('active');
    });

    setTimeout(function () {
      toast.classList.remove('active');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, duration || 2200);
  }

  /**
   * Redirect to /account/login. Shopify's hosted login page (new customer accounts) does not
   * currently honor login_hint / email for prefill, so we copy the email to clipboard and
   * show a toast telling the user to paste. We still pass login_hint / email / return_to so
   * that classic themes (and any future support) pick them up automatically.
   */
  function goToShopifyLogin() {
    var input = document.getElementById('auth-email-input');
    if (!input) return;
    var email = (input.value || '').trim();
    if (!email) {
      input.focus();
      input.classList.add('auth-modal-email-error');
      setTimeout(function () {
        input.classList.remove('auth-modal-email-error');
      }, 2000);
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      input.classList.add('auth-modal-email-error');
      setTimeout(function () {
        input.classList.remove('auth-modal-email-error');
      }, 2000);
      return;
    }
    input.classList.remove('auth-modal-email-error');

    var url = buildLoginUrl({ email: email });

    copyToClipboard(email).then(function (ok) {
      var msg = ok
        ? 'Email copied — paste it on the next page to get your code'
        : 'Redirecting to sign-in — please re-enter your email';
      showToast(msg, 2200);
      close();
      setTimeout(function () {
        window.location.href = url;
      }, 650);
    });
  }

  function signInWithShop() {
    close();
    window.location.href = buildLoginUrl();
  }

  // Initialize
  function init() {
    // Close on ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        close();
      }
    });

    // Close when clicking outside the modal
    document.addEventListener('click', function (e) {
      var el = getModal();
      if (!el) return;
      if (!el.classList.contains('active')) return;
      // If click is outside the modal and not on the login trigger button
      if (!el.contains(e.target) && !e.target.closest('[data-auth-trigger]')) {
        close();
      }
    });

    var emailInput = document.getElementById('auth-email-input');
    if (emailInput) {
      emailInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          goToShopifyLogin();
        }
      });
    }
  }

  // Run init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /**
   * Transition to a specific step
   */
  function toStep(stepId) {
    document.querySelectorAll('.auth-step').forEach(el => el.classList.remove('active'));
    var target = document.getElementById('auth-step-' + stepId);
    var titleEl = document.getElementById('auth-modal-title');

    if (target) {
      target.classList.add('active');
    }

    if (stepId === 'code') {
      var emailInputEl = document.getElementById('auth-email-input');
      var email = emailInputEl ? (emailInputEl.value || '').trim() : '';
      var displayEmail = document.getElementById('display-email');
      if (displayEmail) displayEmail.textContent = email || 'your email';

      if (titleEl) {
        titleEl.textContent = 'PRESTIGE';
        titleEl.style.fontSize = '32px';
        titleEl.style.letterSpacing = '2px';
        titleEl.style.width = '100%';
        titleEl.style.textAlign = 'center';
      }
    } else {
      if (titleEl) {
        titleEl.textContent = 'Sign in or create account'; // Should ideally use i18n
        titleEl.style.fontSize = '';
        titleEl.style.letterSpacing = '';
        titleEl.style.textAlign = '';
        titleEl.style.width = '';
      }
    }
  }

  // Public API
  return {
    open: open,
    close: close,
    toggle: toggle,
    toStep: toStep,
    goToShopifyLogin: goToShopifyLogin,
    signInWithShop: signInWithShop
  };
})();
